module.exports = __webpack_public_path__ + "static/media/contracts.52b18538.svg";